import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/MISCCVarianceReport';


const MISCCVarianceReport = ({ t }) => (
  <Container>
    <Row>
     
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

MISCCVarianceReport.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(MISCCVarianceReport);
